var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUpGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.14747 1.02291C7.95958 0.8602 7.6807 0.8602 7.49282 1.02291L0.173675 7.36148C-0.176276 7.66454 0.0380604 8.23944 0.501003 8.23944H4.15987V12.2394C4.15987 12.5156 4.38373 12.7394 4.65987 12.7394H10.6599C10.936 12.7394 11.1599 12.5156 11.1599 12.2394V8.23944H15.1393C15.6022 8.23944 15.8166 7.66454 15.4666 7.36148L8.14747 1.02291Z",
    fill: "#00C853"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpGreen);
export default __webpack_public_path__ + "static/media/Up Green.b2af9b0fd51ed2324c97adaeff4a179a.svg";
export { ForwardRef as ReactComponent };